import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";

const TargetEgridSection = (props) => {
	const register = props.register;
	const isEditMode = props.isEditMode;
	const setValue = props.setValue;
	const watch = props.watch;
	const data = props.data;

	const january = watch("january_egrid", data.january_egrid);
	const february = watch("february_egrid", data.february_egrid);
	const march = watch("march_egrid", data.march_egrid);
	const april = watch("april_egrid", data.april_egrid);
	const may = watch("may_egrid", data.may_egrid);
	const june = watch("june_egrid", data.june_egrid);
	const july = watch("july_egrid", data.july_egrid);
	const august = watch("august_egrid", data.august_egrid);
	const september = watch("september_egrid", data.september_egrid);
	const october = watch("october_egrid", data.october_egrid);
	const november = watch("november_egrid", data.november_egrid);
	const december = watch("december_egrid", data.december_egrid);

	const [errors, setErrors] = useState({});

	/**
	 * Handle input change
	 * @param {event} evt
	 * @returns
	 */
	const handleChange = (evt, inputName) => {
		const value = evt.target.value;
		setValue(inputName, value);
	};

	useEffect(() => {
		const monthlyEGrid = [
			january,
			february,
			march,
			april,
			may,
			june,
			july,
			august,
			september,
			october,
			november,
			december,
		];

		const summedEGrid = monthlyEGrid.reduce(
			(a, b) => parseFloat(a) + parseFloat(b)
		);

		props.setTotalEGrid(summedEGrid);
	}, [
		january,
		february,
		march,
		april,
		may,
		june,
		july,
		august,
		september,
		october,
		november,
		december,
	]);

	useEffect(() => {
		const errorEntries = Object.entries(props.errors);
		const irrErrorEntries = errorEntries.map((entry) => {
			if (entry[0].includes("egrid")) return entry;
			else return "";
		});

		const filteredErrors = irrErrorEntries.filter((entry) => entry !== "");

		setErrors(filteredErrors);
	}, [props.errors]);

	return (
		<>
			<hr />
			<h5>E Grid (MWh)</h5>
			{errors.length > 0 && (
				<span className="required">*E Grid (MWh) fields required</span>
			)}
			<hr />
			<Row>
				<Col md="4">
					<Row>
						<Col md="3">
							<label>January</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={january}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "january_egrid")}
								name="january_egrid"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>February</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={february}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "february_egrid")}
								name="february_egrid"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>March</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={march}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "march_egrid")}
								name="march_egrid"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>April</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={april}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "april_egrid")}
								name="april_egrid"
							></input>
						</Col>
					</Row>
				</Col>
				<Col md="4">
					<Row>
						<Col md="3">
							<label>May</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={may}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "may_egrid")}
								name="may_egrid"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>June</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={june}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "june_egrid")}
								name="june_egrid"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>July</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={july}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "july_egrid")}
								name="july_egrid"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>August</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={august}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "august_egrid")}
								name="august_egrid"
							></input>
						</Col>
					</Row>
				</Col>
				<Col md="4">
					<Row>
						<Col md="3">
							<label>September</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={september}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "september_egrid")}
								name="september_egrid"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>October</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={october}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "october_egrid")}
								name="october_egrid"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>November</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={november}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "november_egrid")}
								name="november_egrid"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>December</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={december}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "december_egrid")}
								name="december_egrid"
							></input>
						</Col>
					</Row>
				</Col>
			</Row>
		</>
	);
};

export default TargetEgridSection;
